import type { CSSProperties, FC } from 'react'

export type MemberWorkspaceKindBadgeVariant = 'personal' | 'team'

const labels: Record<MemberWorkspaceKindBadgeVariant, string> = {
  personal: 'Personal',
  team: 'Team',
}

const baseStyle: CSSProperties = {
  display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999,
  border: '1px solid var(--border)', color: 'var(--text-muted)', background: 'transparent',
  fontSize: 10, fontWeight: 600, letterSpacing: '0.06em', lineHeight: 1, textTransform: 'uppercase',
}

export const MemberWorkspaceKindBadge: FC<{ readonly variant: MemberWorkspaceKindBadgeVariant }> = ({ variant }) => (
  <span aria-label={`${labels[variant]} workspace`} style={variant === 'personal' ? { ...baseStyle, borderColor: 'var(--accent)', color: 'var(--accent)' } : baseStyle}>
    {labels[variant]}
  </span>
)
